import { axiosApi } from "../../../../../api/dbAxios";

export const deletePromptLibrary = async (id: number) => {
  try {
    const response = await axiosApi.delete(`/prompt/${id}/`);
    return response.data;
  } catch (error: any) {
    throw error.response.data.detail;
  }
};
